import { MainContainerStyleInterface } from "./main_container_interface";

export const mainContainerDefaultStyle: MainContainerStyleInterface = {
    backgroundColor: "gray-300",
    containerBackgroundColor: "white",
    containerMaxWidth: "7xl",
    titleColor: "black",
};
